import { CONNECTIVITY_ID } from '../partials/constants'

export const isSelectedConnectivity = reportTypes =>
    reportTypes?.some(selected => selected.id === CONNECTIVITY_ID)
